import { render, staticRenderFns } from "./responsibility-center.vue?vue&type=template&id=2d180f00&"
import script from "./responsibility-center.vue?vue&type=script&lang=js&"
export * from "./responsibility-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports